import Flux from '../../flux/Flux.js';
import PropTypes from 'prop-types';
import withStaticLoader from '../HigherOrderComponents/Utility/withStaticLoader.js';
import Grid2 from '../Grid2/Grid2.js';
import TopCamsTile from './TopCamsTile.js';
import TopCamsTopTile from './TopCamsTopTile.js';
import style from './TopCams.module.less';
import Translations from '../../utils/Translations.js';
import FormCheckbox from '../Form/FormCheckbox.js';
import Header from './Header.js';
import { getTranslationForCategory } from './TopCamsHelper.js';
import { useEffect, useState } from 'react';

const Grid = withStaticLoader(Grid2);

const TopCamsGrid = (props) => {
	const { actors = [], loadData, type, isMobile, loading } = props;

	const [filterChecked, setFilterChecked] = useState(false);
	const [showDescription, setShowDescription] = useState(true);

	const top = actors.slice(0, 3);
	const rest = actors.slice(3, actors.length);

	useEffect(() => {
		setFilterChecked(false);
		loadData(type);
	}, [type]);

	const onChangeFn = (checked) => {
		setFilterChecked(checked);
		if (checked) {
			loadData(type, true);
		} else {
			loadData(type);
		}
	};

	let columnsTop3 = { xs: 2, sm: 3, md: 3, lg: 3 };
	let columns = { xs: 2, sm: 3, md: 4, lg: 4 };
	if (isMobile) {
		columns = { xs: 1 };
		columnsTop3 = { xs: 1 };
	}

	const translation = getTranslationForCategory(type, isMobile);

	const getCategoryContent = (category) => {
		let content;
		switch (category) {
			case Flux.Constants.TopCams.Categories.VIDEOCALL:
				const onlineCount = actors.filter((actor) => actor.onlineVideocall).length;
				let headline;

				if (!isMobile) {
					headline = (
						<span className={style.videocallHeadline}>
							{Translations.get('top_cams.title-videocall')}{' '}
							{translation.infoText && (
								<span className={style.headerInfo}>
									{' '}
									/ {onlineCount} {translation.infoText}
								</span>
							)}
						</span>
					);
				} else {
					if (onlineCount > 0) {
						headline = (
							<>
								<span className={style.videocallHeadline}>
									<i className={style.headerBannerInfoIcon + ' icon -icon-live-full ' + style.pulse} />
									{Translations.get('top_cams.now-online')}
									<span className={style.headerInfo}>
										{' '}
										/ {onlineCount} {Translations.get('CollectionSearchResultsActors')}
									</span>
								</span>{' '}
								<i
									className={style.videocallInfo + ' icon -icon-round-info-full'}
									onClick={() => setShowDescription(!showDescription)}
								/>
							</>
						);
					} else {
						headline = (
							<>
								<span className={style.videocallHeadline}>
									{Translations.get('top_cams.headline-videocall')}
									<span className={style.headerInfo}>
										{' '}
										/ {onlineCount} {translation.infoText}
									</span>
								</span>
								<i
									className={style.videocallInfo + ' icon -icon-round-info-full'}
									onClick={() => setShowDescription(!showDescription)}
								/>
							</>
						);
					}
				}

				content = (
					<div className={style.top100Container}>
							<div className={style.headerTitle}>{headline}</div>
							<Grid
								defaultTileClass={TopCamsTile}
								tileData={actors}
								defaultTileConfig={{ isMobile: isMobile, isDetailPage: true, type: type }}
								columns={columns}
								tilePadding={Flux.Constants.Grid2.TilePadding.LARGE}
								headlineType={'div'}
								lazyImageLoading={true}
								loading={props.loading}
							/>
						</div>
				);
				break;
			case Flux.Constants.TopCams.Categories.TOP100:
			case Flux.Constants.TopCams.Categories.FAVORITES:
			case Flux.Constants.TopCams.Categories.CHATS:
			default:
				if (filterChecked) {
					content = (
						<div className={style.top100Container + ' ' + style.paddingTop}>
							{!isMobile && <div className={style.top100Spacer} />}
							{isMobile && (
								<div className={style.headline}>
									<div className={style.infoTextCollapsed}>
										<div className={style.headlineControls}>
											<i
												className={style.infoIcon + ' icon -icon-round-info-full'}
												onClick={() => setShowDescription(!showDescription)}
											/>
											{type !== Flux.Constants.TopCams.Categories.VIDEOCALL && (
												<FormCheckbox
													name="filterOnline"
													label={Translations.get('MessengerShowOnlyOnline')}
													checked={filterChecked}
													onValueChange={onChangeFn}
													labelClassName="h-color-fg-description"
												/>
											)}
										</div>
									</div>
								</div>
							)}
							<Grid
								defaultTileClass={TopCamsTile}
								tileData={actors.filter((actor) => actor.online)}
								defaultTileConfig={{ isMobile: isMobile, isDetailPage: true, type: type }}
								columns={columns}
								tilePadding={Flux.Constants.Grid2.TilePadding.LARGE}
								headlineType={'div'}
								lazyImageLoading={true}
								loading={props.loading}
							/>
						</div>
					);
				} else {
					content = (
						<>
							<div className={style.top3Container}>
								<div className={style.headline}>
									{Translations.get(isMobile || props.useShortHeadline ? 'Ranking1-3' : 'CategoryTop100HighlightCaption')}
									{isMobile && (
										<div className={style.headlineControls}>
											<i
												className={style.infoIcon + ' icon -icon-round-info-full'}
												onClick={() => setShowDescription(!showDescription)}
											/>
											{type !== Flux.Constants.TopCams.Categories.VIDEOCALL && (
												<FormCheckbox
													name="filterOnline"
													label={Translations.get('MessengerShowOnlyOnline')}
													checked={filterChecked}
													onValueChange={onChangeFn}
													labelClassName="h-color-fg-description"
												/>
											)}
										</div>
									)}
								</div>
								<Grid
									defaultTileClass={TopCamsTopTile}
									tileData={top}
									defaultTileConfig={{ isMobile: isMobile, isDetailPage: true, type: type }}
									columns={columnsTop3}
									tilePadding={Flux.Constants.Grid2.TilePadding.LARGE}
									headlineType={'div'}
									lazyImageLoading={true}
									loading={loading}
								/>
							</div>
							<div className={style.top100Container}>
								<div className={style.headline}>
									{Translations.get('CategoryTop100ContentCaption-var', props.total || props.actors.length)}
								</div>
								<Grid
									defaultTileClass={TopCamsTile}
									tileData={rest}
									defaultTileConfig={{ isMobile: isMobile, isDetailPage: true, type: type }}
									columns={columns}
									tilePadding={Flux.Constants.Grid2.TilePadding.LARGE}
									headlineType={'div'}
									lazyImageLoading={true}
									loading={props.loading}
								/>
							</div>
						</>
					);
				}
		}

		return content;
	};

	return (
		<>
			<Header
				text={Translations.get(translation.header)}
				infoText={Translations.get(translation.infoText)}
				subText={Translations.get(translation.description)}
				isMobile={isMobile}
				showDescription={showDescription}
				setShowDescription={setShowDescription}
				bannerImage={'/assets/img/topLists/' + (isMobile ? 'background_mobile.png' : 'background.webp')}
				isVideocall={type === Flux.Constants.TopCams.Categories.VIDEOCALL}
				onlineModels={actors.filter((actor) => actor.onlineVideocall)}
				filterChecked={filterChecked}
				onChangeFn={onChangeFn}
				showOnlinefilter={props.showOnlinefilter}
			/>
			{getCategoryContent(type)}
		</>
	);
};

export default TopCamsGrid;

TopCamsGrid.propTypes = {
	loadData: PropTypes.func.isRequired,
	type: PropTypes.oneOf(Object.values(Flux.Constants.TopCams.Categories)),
	actors: PropTypes.array,
	isMobile: PropTypes.bool,
	loading: PropTypes.bool,
	showOnlinefilter: PropTypes.bool,
	useShortHeadline: PropTypes.bool,
	total: PropTypes.number,
};

TopCamsGrid.defaultProps = {
	isMobile: false,
	loading: true,
	showOnlinefilter: true,
	useShortHeadline: false,
	total: null,
};
